<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.resultado_economico"
            :valid.sync="fieldsComputed.resultado_economico.valid"
            :label="fieldsComputed.resultado_economico"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.resultado_inovacao"
            :valid.sync="fieldsComputed.resultado_inovacao.valid"
            :label="fieldsComputed.resultado_inovacao"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">        
        <div class="col">
          <input-v
            v-model="projeto.ods_contemplados"
            :valid.sync="fieldsComputed.ods_contemplados.valid"
            :label="fieldsComputed.ods_contemplados"            
            :editable="canEdit"
            :opts="computedOpts"
          >
          </input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.justificativa_ods"
            :valid.sync="fieldsComputed.justificativa_ods.valid"
            :label="fieldsComputed.justificativa_ods"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.alinhamento_politicas"
            :valid.sync="fieldsComputed.alinhamento_politicas.valid"
            :label="fieldsComputed.alinhamento_politicas"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
         <div class="col">
          <g-file-picker
            :value="anexoAlinhamentoPoliticas"
            @update:value="$emit('update:anexoAlinhamentoPoliticas', $event)"
            label="Anexo complementar para comprovação da atividade de PD&I"
            multiple
            :disabled="!canEdit"
            :show-download="true"
            :label-bold="true"
            :max-file-size="10485760"
          />
        </div>
      </div>
      <div class="row mt-n2" v-if="projeto.alinhamento_politicas == 1">
        <div class="col">
          <input-v
            v-model="projeto.justificativa_alinhamento_politicas"
            :valid.sync="fieldsComputed.justificativa_alinhamento_politicas.valid"
            :label="fieldsComputed.justificativa_alinhamento_politicas"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.desenvolvimento_empresas"
            :valid.sync="fieldsComputed.desenvolvimento_empresas.valid"
            :label="fieldsComputed.desenvolvimento_empresas"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2" v-if="projeto.desenvolvimento_empresas == 1">
        <div class="col">
          <input-v
            v-model="projeto.desenvolvimento_empresas_justificativa"
            :valid.sync="fieldsComputed.desenvolvimento_empresas_justificativa.valid"
            :label="fieldsComputed.desenvolvimento_empresas_justificativa"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
        <div class="col">
          <g-file-picker
            :value="anexoDesenvolvimentoEmpresas"
            @update:value="$emit('update:anexoDesenvolvimentoEmpresas', $event)"
            label="Anexo Comprobatório"
            multiple
            :disabled="!canEdit"
            :show-download="true"
            :label-bold="true"
            :max-file-size="10485760"
          />
        </div>
      </div>
      <div class="row mt-n2">
        <!-- <div class="col">
          <input-v
            v-model="projeto.material_consumo"
            :valid.sync="fieldsComputed.material_consumo.valid"
            :label="fieldsComputed.material_consumo"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div> -->
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.informacoes_complementares"
            :valid.sync="fieldsComputed.informacoes_complementares.valid"
            :label="fieldsComputed.informacoes_complementares"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LBEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";

const odsOptions = [
  { id: 1, descricao: '1 - Erradicação da Pobreza' },
  { id: 2, descricao: '2 - Fome Zero e Agricultura Sustentável' },
  { id: 3, descricao: '3 - Saúde e Bem-Estar' },
  { id: 4, descricao: '4 - Educação de Qualidade' },
  { id: 5, descricao: '5 - Igualdade de Gênero' },
  { id: 6, descricao: '6 - Água Potável e Saneamento' },
  { id: 7, descricao: '7 - Energia Limpa e Acessível' },
  { id: 8, descricao: '8 - Trabalho Decente e Crescimento Econômico' },
  { id: 9, descricao: '9 - Indústria, Inovação e Infraestrutura' },
  { id: 10, descricao: '10 - Redução das Desigualdades' },
  { id: 11, descricao: '11 - Cidades e Comunidades Sustentáveis' },
  { id: 12, descricao: '12 - Consumo e Produção Responsáveis' },
  { id: 13, descricao: '13 - Ação Contra a Mudança Global do Clima' },
  { id: 14, descricao: '14 - Vida na Água' },
  { id: 15, descricao: '15 - Vida Terrestre' },
  { id: 16, descricao: '16 - Paz, Justiça e Instituições Eficazes' },
  { id: 17, descricao: '17 - Parcerias e Meios de Implementação' },
];

export default {
  components: {
    'input-v': () => import('@/components/input-v.vue'),
    "g-file-picker": () => import("@/components/g-file-picker.vue"),
  },
  data() { 
    return {
      fields,
    }
  },
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    anexoAlinhamentoPoliticas: {
      type: Array,
      default: () => []
    },
    anexoDesenvolvimentoEmpresas: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    computedOpts() {
      return {
        ...this.opts,
        ods: odsOptions,
      };
    },
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.resultados);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
  },
  methods: {
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
</style>
